var _g, _path, _g2, _g3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImage1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1020,
    height: 1036,
    viewBox: "0 0 1020 1036",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_196_3331)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M304.873 391.099L469.045 675.128L304.873 959.093L140.766 675.128L304.873 391.099Z",
    fill: "url(#paint0_linear_196_3331)",
    fillOpacity: 0.84
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M427.406 111.39H755.621L917.34 391.099L753.168 675.128H429.859L591.514 395.355L427.406 111.39Z",
    fill: "url(#paint1_linear_196_3331)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_196_3331)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M725.526 268L887.826 549.192L723.654 833.221L562 553.448L725.526 268Z",
    fill: "url(#paint2_linear_196_3331)",
    fillOpacity: 0.16
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_b_196_3331)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M287.859 472.761L364.674 605.786L361.799 610.765L284.984 477.748L287.859 472.761ZM354.348 357.631L431.163 490.648L427.838 496.405L351.024 363.388L354.348 357.631ZM347.699 369.144L424.513 502.161L421.188 507.918L344.374 374.901L347.699 369.144ZM341.049 380.657L417.863 513.674L414.539 519.431L337.724 386.414L341.049 380.657ZM334.399 392.17L411.214 525.187L407.889 530.944L331.075 397.927L334.399 392.17ZM327.75 403.683L404.564 536.7L401.239 542.457L324.425 409.44L327.75 403.683ZM321.1 415.196L397.914 548.213L394.59 553.97L317.775 420.953L321.1 415.196ZM314.458 426.709L391.265 559.726L387.94 565.483L311.133 432.466L314.458 426.709ZM307.808 438.222L384.615 571.247L381.298 577.003L304.483 443.979L307.808 438.222ZM301.159 449.735L377.973 582.76L374.648 588.516L297.834 455.492L301.159 449.735ZM294.509 461.248L371.323 594.273L367.998 600.022L291.184 467.005L294.509 461.248Z",
    fill: "url(#paint3_linear_196_3331)",
    fillOpacity: 0.4
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_196_3331",
    x: 119.766,
    y: 370.099,
    width: 370.279,
    height: 609.995,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 10.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_196_3331"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_196_3331",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_196_3331",
    x: 542,
    y: 248,
    width: 365.826,
    height: 605.221,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_196_3331"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_196_3331",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_b_196_3331",
    x: 268.984,
    y: 341.631,
    width: 178.179,
    height: 285.133,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_196_3331"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_196_3331",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_196_3331",
    x1: 304.474,
    y1: 970.993,
    x2: -106.478,
    y2: 519.684,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1735A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.685839,
    stopColor: "#099B91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_196_3331",
    x1: 932.854,
    y1: 611.533,
    x2: 340.641,
    y2: 467.064,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1733A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#099B91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_196_3331",
    x1: 898.143,
    y1: 769.459,
    x2: 491.506,
    y2: 703.661,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A3EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3FF4E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_196_3331",
    x1: 435.791,
    y1: 582.209,
    x2: 253.375,
    y2: 552.64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2CDF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#099B91"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage1);
export default __webpack_public_path__ + "static/media/image-1.e526c93799d0b93b463e07ef21c75400.svg";
export { ForwardRef as ReactComponent };